import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import Button from '../button';
const GROUP_TYPES = {
  page: {
    title: Text.H4,
    primaryBtn: Button,
    secondaryBtn: Button
  },
  modal: {
    title: Text.H6,
    primaryBtn: Button,
    secondaryBtn: Button
  },
  empty: {
    primaryBtn: Button.Text
  }
};
const CenteredText = styled(Text.BodyBase)`
  text-align: center;
`;
const StyledContainer = styled.View`
  flex-direction: column;
  justify-content: center;
`;
const TextGroupContainer = styled.View`
  flex-direction: column;
  align-items: center;
`;
export default function Group(props) {
  const groupType = GROUP_TYPES[props.type];
  const TitleText = groupType.title;
  const PrimaryButton = groupType.primaryBtn;
  const SecondaryButton = groupType.secondaryBtn;
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(TextGroupContainer, null, TitleText && /*#__PURE__*/React.createElement(CenteredText, null, /*#__PURE__*/React.createElement(TitleText, {
    color: Colors.gray600
  }, props.title), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  })), /*#__PURE__*/React.createElement(CenteredText, {
    color: Colors.gray500
  }, props.body)), /*#__PURE__*/React.createElement(Spacer, {
    size: props.type === 'page' ? 'f24' : 'f16',
    height: true
  }), /*#__PURE__*/React.createElement(PrimaryButton, {
    onPress: props.primaryBtn.onPress
  }, props.primaryBtn.label), SecondaryButton && props.secondaryBtn.label !== '' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(SecondaryButton, {
    type: "tertiary",
    onPress: props.secondaryBtn.onPress
  }, props.secondaryBtn.label)));
}
const buttonShape = {
  label: PropTypes.string,
  onPress: PropTypes.func
};
Group.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  primaryBtn: PropTypes.shape(buttonShape),
  secondaryBtn: PropTypes.shape(buttonShape),
  type: PropTypes.oneOf(Object.keys(GROUP_TYPES))
};
Group.defaultProps = {
  title: '',
  body: '',
  primaryBtn: {
    label: '',
    onPress: () => {}
  },
  secondaryBtn: {
    label: '',
    onPress: () => {}
  },
  type: 'page'
};
//# sourceMappingURL=group.js.map